const ExpandImage = (props) => (
  <svg
    xmlSpace="preserve"
    style={{enableBackground: "new 0 0 122.88 122.87",}}
    viewBox="0 0 122.88 122.87"
    {...props}
  >
    <path d="M122.88 77.63v41.12a4.12 4.12 0 0 1-4.12 4.12H77.33v-9.62h35.95V77.63h9.6zM77.39 9.53V0h41.37a4.12 4.12 0 0 1 4.12 4.12V45.3h-9.63V9.53H77.39zM9.63 45.24H0V4.12C0 1.85 1.85 0 4.12 0h41v9.64H9.63v35.6zm35.44 68.03v9.6H4.12c-2.28 0-4.12-1.85-4.12-4.13V77.57h9.63v35.71h35.44v-.01z" />
  </svg>
)
export default ExpandImage;
